import React from "react";

import qrCode from "../../assets/icons/ic_qrcode.png";
import qrCodeLarge from "../../assets/icons/ic_qrcode@2x.png";

const QRCodeIcon = qrCode;
const QRCodeIconLarge = qrCodeLarge;

export {QRCodeIcon, QRCodeIconLarge}
